import { render, staticRenderFns } from "./passprove.vue?vue&type=template&id=0972e7c4"
import script from "./passprove.vue?vue&type=script&lang=js"
export * from "./passprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports